module.exports = __webpack_public_path__ + "static/media/check-icon.224d2e57.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/check-icon.svg
// module id = 237
// module chunks = 0